import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import mapEnabledWorkflows from './utils/map-enabled-workflows';
import { workflow } from './utils/parameters';

ReactDOM.render(<App />, document.getElementById('root'));

(() => {
  const isRedirected = mapEnabledWorkflows(workflow).tswebEnabled
    || window.sessionStorage.getItem('embedded-ts-web-context');

  if (!isRedirected) return;

  const footer = document.querySelector('footer');
  if (footer) footer.classList.add('hide');

  const appContainer = document.querySelector('.App');
  if (appContainer) appContainer.style.padding = '0px';
})();
